<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-argos-event-mutes-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()"
                                   [networkDevice]="networkDevice" [entity]="entity"
                                   [collectionNode]="collectionNode" [backboneEquipment]="backboneEquipment">
    </app-argos-event-mutes-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-argos-event-mutes-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters" [disableRouterLink]="true">
    </app-argos-event-mutes-list>
  </ng-template>
</div>